

let cherche = ''
let timeout



export const initRecherche = function () {
    document.querySelector('#recherche').addEventListener('keyup', function(e) {
        preRecherche(e)
      });   
     // document.querySelector('#recherche').focus();
      if (document.querySelector('.ico-recherche')) {
        document.querySelector('.ico-recherche').addEventListener('click', event => {
          document.querySelector('.zone-search').style.top = '0px'
        })
        document.querySelector('.fermer-recherche').addEventListener('click', event => {
          document.querySelector('.zone-search').style.top = '-160px'
          document.querySelector('#recherche').value = ''
        })
      }
      
}


export const initRecherchePage = function () {
    //document.querySelector('#recherche-page').focus();
    document.querySelector('#recherche-page').addEventListener('keyup', function(e) {
        preRecherche(e)
      });

    // Si champ déjà rempli on lance une recherche 
    cherche = document.querySelector('#recherche-page').value;
    if (cherche.length>0) recherche(cherche)
}


const preRecherche = function (e) {

  // Saisie touche entrée

  if (document.querySelector('.zone-load-blog-conteneur')) {
    document.querySelector('.zone-load-blog-conteneur').style.display = 'none'
    document.querySelector('.zone-load-actus-conteneur').style.display = 'none'
  }


  var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  var regex = new RegExp("^[a-zA-Z0-9]+$");

  if ( e.keyCode !== 8 && e.keyCode !== 46 ) { // si ce n'est pas un delete ou backpace
    if (!regex.test(key) ) { // Si ce n'et pas un charactère
      e.preventDefault();
      return false;
    }
    if (e.keyCode == 13) { // si c'est un retour
      e.preventDefault();
      return false;
    }
  }

  if (document.querySelector('#recherche-page')) cherche = document.querySelector('#recherche-page').value;
  else if (document.querySelector('#recherche')) cherche = document.querySelector('#recherche').value;

  clearTimeout(timeout);

   // Make a new timeout set to go off in 800ms
   timeout = setTimeout(function () {
            if (window.location.href.indexOf("recherche") > -1) {
                // lancer la recherche
             
                recherche(cherche)
            }
            // Aller sur la page de recherche
            else window.location.assign("/recherche?s="+cherche)
   }, 800);
}

const recherche = function(cherche) {
 
    let zoneBlog = document.querySelector('.zone-load-blog')
    let zoneActus = document.querySelector('.zone-load-actus')
    let zoneResultats = document.querySelector('.zone-load-resultat')

    let zoneBlogConteneur = document.querySelector('.zone-load-blog-conteneur')
    let zoneActusConteneur = document.querySelector('.zone-load-actus-conteneur')


    const url =window.location.origin+'/wp-json/veltys/v1/recherche/?s='+cherche

    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      
      if ( (data.blog.length==0) && (data.actualites.length==0)) {
    
        zoneResultats.style.display = 'block'
      
      }
      else {
            zoneResultats.innerHTML = ''
            zoneResultats.style.display = 'none'
            zoneBlog.innerHTML = ''
            zoneActus.innerHTML = ''

            if (data.blog.length>0) {
                zoneBlogConteneur.style.display = 'block'
                zoneBlog.innerHTML = data.blog
            }
            if  (data.actualites.length>0) {
                zoneActusConteneur.style.display = 'block'
                zoneActus.innerHTML = data.actualites
            }
      }

    });  

}

